import { render, staticRenderFns } from "./CustomerLoanListItem.vue?vue&type=template&id=42e1a613&lang=pug&"
import script from "./CustomerLoanListItem.vue?vue&type=script&lang=js&"
export * from "./CustomerLoanListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports